import React from 'react';
import { navigate } from '../services/navigation';

function TopBar({ user, onLogout }) {
  const handleNavigate = (path) => (event) => {
    event.preventDefault();
    navigate(path);
  };

  return (
    <header className="topbar">
      <a className="brand" href="/" onClick={handleNavigate('/')}>
        <img
          className="brand-logo"
          src="/home_logo.png?v=2"
          alt="Talkali"
          width="170"
          height="50"
        />
      </a>

      <nav className="topbar-nav">
        <a className="nav-link" href="/" onClick={handleNavigate('/')}>
          Home
        </a>
        {user ? (
          <>
            <a className="nav-link" href="/dashboard" onClick={handleNavigate('/dashboard')}>
              Dashboard
            </a>
            <button className="primary-button small-button" onClick={onLogout}>
              Log out
            </button>
          </>
        ) : (
          <>
            <a className="nav-link" href="/login" onClick={handleNavigate('/login')}>
              Log in
            </a>
            <a className="primary-button small-button" href="/#apps-section">
              Open app
            </a>
          </>
        )}
      </nav>
    </header>
  );
}

export default TopBar;